import React from "react";

const items = [
  "Heavy Cotton",
  "Made in Blue Mountains",
  "Limited Drops",
  "Garment Dyed",
  "Australian Grown",
  "Slow Fashion",
];

export default function Marquee() {
  const row = [...items, ...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/5 bg-[#0a0f1d] py-8 md:py-10 overflow-hidden"
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-14 pr-14 whitespace-nowrap"
            aria-hidden={i >= items.length}
          >
            {i % 2 === 0 ? (
              <span className="font-serif-display italic text-white/85 text-2xl md:text-4xl">
                {t}
              </span>
            ) : (
              <span className="text-outline uppercase tracking-[0.35em] text-lg md:text-2xl font-light">
                {t}
              </span>
            )}
            <span className="text-[#D4AF37] text-xs">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
